import {makeAdUrl} from '@frontend/helpers'
import type {AdPreviewDataForList} from '@frontend/modules/public/ads/AdsModuleTypes'
import {SellerReviewsListModal} from '@frontend/modules/public/seller_info/components/SellerReviewsListModal'
import {mdiStar} from '@mdi/js'
import {useState} from 'react'
import {Link} from 'react-router-dom'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {HtmlContent} from 'swayok-react-mdb-ui-kit/components/Typography/HtmlContent'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'
import {AnalyticsEventReporter} from '../../../../../helpers/AnalyticsEventReporter'
import {AdLikeIconButton} from './AdLikeIconButton'
import {AdPrice} from './AdPrice'

interface AdsListItemInfoProps {
    ad: AdPreviewDataForList
    onAdDataChange: (ad: AdPreviewDataForList) => void
}

// Содержимое карточки предпросмотра объявления в списке.
export function AdsListItemInfo(props: AdsListItemInfoProps) {

    const {
        ad,
        onAdDataChange,
    } = props

    // Видимость окна со списком отзывов о продавце.
    const [
        isReviewsModalVisible,
        setIsReviewsModalVisible,
    ] = useState<boolean | null>(null)

    const hasReviews: boolean = ad.seller.reviewsCount > 0

    const sellerLineClassName: string = 'd-flex d-xl-none flex-row flex-wrap align-items-center gap-2 fs-7 text-start'

    const sellerLine = (
        <>
            <span className="fw-700">
                {ad.seller.name}
            </span>
            {ad.seller.rating > 0 && (
                <span className="d-flex flex-row align-items-center gap-1 fw-700">
                    <Icon
                        path={mdiStar}
                        color="orange"
                        size={18}
                    />
                    {ad.seller.rating}
                </span>
            )}
            {hasReviews && (
                <span className="text-gray">
                    ({ad.seller.reviewsCount})
                </span>
            )}
        </>
    )

    // Обработчик нажатия на карточку объявления.
    const onClick = useEventCallback(() => {
        AnalyticsEventReporter.clickOnAdFromList(ad)
    })

    return (
        <div className="offered-item-card-info flex-1">
            <div className="d-flex flex-row align-items-start justify-content-between gap-2">
                <Link
                    className="offered-item-card-title fw-700"
                    target="_blank"
                    to={makeAdUrl(ad.slugWithId, ad.categorySlugWithId)}
                    rel="noreferrer"
                    onClick={onClick}
                >
                    {ad.title}
                </Link>
                <AdLikeIconButton
                    ad={ad}
                    isFavourite={ad.isFavourite}
                    noLabel
                    className="offered-item-card-like flex-shrink-0"
                    onFavoriteStateChange={isFavourite => onAdDataChange({...ad, isFavourite})}
                />
            </div>
            <div className="mt-2 d-flex flex-column align-items-start gap-2">
                <AdPrice
                    price={ad.price}
                    previousPrice={ad.previousPrice}
                />
                {hasReviews ? (
                    <>
                        <Button
                            color="link"
                            className={sellerLineClassName}
                            onClick={() => setIsReviewsModalVisible(true)}
                        >
                            {sellerLine}
                        </Button>
                        <SellerReviewsListModal
                            seller={ad.seller}
                            show={isReviewsModalVisible}
                            onClose={() => setIsReviewsModalVisible(false)}
                        />
                    </>
                ) : (
                    <div className={sellerLineClassName}>
                        {sellerLine}
                    </div>
                )}
                {ad.location && (
                    <div className="fs-7 text-gray">
                        {ad.location}
                    </div>
                )}
                <HtmlContent
                    block
                    html={ad.description}
                    className="offered-item-description text-gray"
                />
            </div>
        </div>
    )
}
